import { createContext, useMemo, useContext } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { StyleSheet, Pressable, Text, View } from 'react-native';

// src/ui/theme/RealmThemeProvider.tsx

// src/config/index.ts
var runtimeRealmLexiconOverrides = {};
var REALMS = {
  cosmos: {
    label: "CHUZI COSMOS",
    short_label: "Cosmos",
    lexicon: {
      genre: "Galaxy",
      story: "Star System",
      scene: "Star",
      scene_choice: "Choice",
      node: "Signal",
      node_type_choice: "Choice",
      node_type_media: "Transmission",
      node_type_go_to_scene: "Warp",
      player: "Voyager",
      library: "Star Chart",
      library_open: "Open Star Chart",
      library_close: "Close Star Chart",
      editor: "Mission Control",
      publish: "Launch",
      experience_realm_idea: "Outer Space",
      the_end: "The End",
      // deprecated — no longer generated
      media_pool: "Cargo Bay",
      scene_graph: "Star Chart",
      watch_path: "Your path",
      untitled_story: "Untitled Star System",
      untitled_scene: "Untitled Star",
      unknown_genre: "Unknown Galaxy",
      scenes_count: "stars",
      choices_count: "choices",
      drafts_published: "Drafts + Launched",
      published_ver: "Launched ver.",
      draft: "Draft",
      no_scenes_yet: "No stars in this chart yet.",
      no_path_yet: "No path to show yet.",
      menu_empty_drafts: "No star systems yet. Chart one to begin.",
      menu_empty_published: "No launched systems in the chart.",
      menu_published_heading: "Launched constellations",
      menu_create_story: "New star system",
      menu_create_film: "Create film",
      film_title_placeholder: "Star system title",
      select_genre: "Select galaxy",
      genre_field_aria: "Galaxy",
      delete_story_verb: "Delete star system",
      title_scene_default: "Launch",
      choices_made_stat: "choices made",
      content_rating: "Audience Class",
      content_rating_field_aria: "Audience class",
      select_content_rating: "Select audience class",
      unrated: "Unclassified",
      viewer_credits: "Fuel Cells",
      creator_credits: "Stardust",
      editor_media_upload: "Upload Transmission",
      editor_media_preview: "Transmission Preview",
      editor_alt_media: "Effects",
      editor_choices: "Choices",
      editor_scene_settings: "Star Settings",
      editor_scene_type_label: "Star",
      editor_title_scene: "Start",
      editor_film_title: "Star System Title",
      editor_film_title_hint: "Click to rename this star system",
      editor_ending_scene: "End",
      editor_play: "Engage",
      editor_pause: "Hold",
      editor_prev_frame: "Previous Frame",
      editor_next_frame: "Next Frame",
      editor_seek: "Seek",
      editor_no_media: "No transmission assigned",
      editor_uploading: "Transmitting\u2026",
      editor_drop_media: "Drop transmission here",
      editor_scene_type: "Star Type",
      editor_save: "Lock In",
      editor_cancel: "Abort",
      editor_create_scene: "Chart Star",
      editor_create_scene_plain: "Create New Scene",
      editor_create_scene_before: "Insert New Star Before",
      editor_create_scene_after: "Insert New Star After",
      editor_create_scene_ahead: "Create New Star",
      editor_create_next_scene: "Chart Next Star",
      editor_create_scene_cost: "1 Stardust",
      editor_delete_scene_cta: "Delete Star",
      editor_delete_scene_confirm: "Click again to confirm",
      editor_scene_locked_delete: "Start star cannot be deleted.",
      editor_scene_color: "Star Hue",
      viewer_continue: "Continue Signal",
      chuzi_ai_name: "Chuzi AI",
      chuzi_ai_create_with: "Create with Chuzi AI",
      chuzi_ai_create_manual: "Enter title manually",
      chuzi_ai_intro: "Answer a few story prompts and Chuzi AI will chart your short story.",
      chuzi_ai_step_of: "Step",
      chuzi_ai_back: "Back",
      chuzi_ai_next: "Next",
      chuzi_ai_scenes_label: "scenes",
      chuzi_ai_creating: "Creating\u2026",
      chuzi_ai_generate_failed: "Story generation failed.",
      chuzi_ai_build_failed: "Failed to build story.",
      chuzi_ai_generate: "Generate scene",
      chuzi_ai_generating: "Generating\u2026",
      chuzi_ai_token_in: "Tokens in",
      chuzi_ai_token_out: "Tokens out",
      chuzi_ai_credits_cost: "AI credits",
      chuzi_ai_scene_credits: "Scene credits",
      chuzi_ai_total_cost: "Total create credits",
      chuzi_ai_insufficient: "Not enough create credits for this generation.",
      chuzi_ai_apply: "Build story",
      chuzi_ai_applying: "Building scenes\u2026",
      chuzi_ai_scene_create: "Create scene with Chuzi AI",
      chuzi_ai_scene_overwrite: "Rewrite scene with Chuzi AI",
      chuzi_ai_scene_brief: "Scene direction",
      chuzi_ai_scene_brief_hint: "Describe what should happen in this scene. Chuzi AI reads your existing story for characters, tone, and style.",
      chuzi_ai_scene_context_note: "Uses your story\u2019s existing scenes, typography, and art direction as context.",
      chuzi_ai_scene_overwrite_confirm: "I understand this replaces this scene\u2019s text and styling.",
      chuzi_ai_scene_apply_create: "Create scene",
      chuzi_ai_scene_apply_overwrite: "Replace scene",
      chuzi_ai_scene_continue_default: "Continue the story with the next scene. Leave the narrative open-ended.",
      chuzi_ai_scene_continue_vibes: "Stay in the same tone and genre ({vibes}).",
      chuzi_ai_scene_continue_characters: "Keep roughly {count} characters in play.",
      chuzi_ai_scene_continue_hook: "Write the next scene continuing from where the story left off. Do not end or resolve the story.",
      editor_scene_nav: "Scene navigation",
      editor_scene_title_hint: "Click to rename this star",
      chuzi_ai_step_protagonist_hint: "Who is your main character? Name, age, personality, and what makes them interesting.",
      chuzi_ai_step_setting: "Setting",
      chuzi_ai_step_setting_hint: "Where and when does the story begin? Describe the world and their everyday life.",
      chuzi_ai_step_conflict: "Conflict",
      chuzi_ai_step_conflict_hint: "What event or problem kicks the story into motion?",
      chuzi_ai_step_journey: "Journey",
      chuzi_ai_step_journey_hint: "What challenges, turning points, climax, and resolution shape the story?",
      chuzi_ai_step_tone: "Tone & mood",
      chuzi_ai_step_tone_hint: "Genre, mood, and atmosphere (e.g. bittersweet sci-fi, cozy mystery, epic fantasy).",
      chuzi_ai_monomyth_hero: "Hero\u2019s Journey: the protagonist",
      chuzi_ai_monomyth_world: "Monomyth: ordinary world",
      chuzi_ai_monomyth_you: "Story Circle: zone of comfort",
      chuzi_ai_monomyth_need: "Story Circle: something isn\u2019t right",
      chuzi_ai_monomyth_go: "Monomyth: crossing the first threshold",
      chuzi_ai_monomyth_search: "Monomyth: road of trials",
      chuzi_ai_monomyth_find: "Monomyth: the ultimate boon",
      chuzi_ai_monomyth_take: "Monomyth: atonement with the father",
      chuzi_ai_monomyth_return: "Monomyth: crossing the return threshold",
      chuzi_ai_monomyth_change: "Monomyth: freedom to live",
      cosmos_cluster_published: "Broadcast Nebula",
      cosmos_cluster_unpublished: "Shipyard Nebula",
      cosmos_cluster_limited: "Relay Nebula",
      cosmos_cluster_jettisoned: "Jettison Nebula",
      jettison_unjettison: "Recover",
      jettison_promote: "Return to Shipyard",
      jettison_purge_story: "Purge",
      jettison_purge_all: "Purge All",
      jettison_days_remaining: "{days}d remaining",
      nav_bar_empty_nebula: "No star systems",
      nebula_chuzi: "CHUZI!",
      published_version_label: "Version",
      system_story_create: "New reserved story",
      publish_tier_private: "Private",
      publish_tier_limited: "Limited access",
      publish_tier_worldwide: "Worldwide",
      hud_unpublish_control: "Jettison",
      hud_retract_control: "Retract",
      unpublish_confirm_hint: "Tap again to confirm",
      create_publish_hint: "Add ratings, genre & coverbox when you broadcast.",
      generator_create_upload: "Create / Upload Transmission",
      generator_generate: "Generate with Chuzi AI",
      generator_vibes_prompt: "Choose your vibes",
      generator_vibes_required: "Pick at least one vibe.",
      generator_audience_prompt: "Who\u2019s your audience?",
      generator_audience_placeholder: "Select reading level",
      generator_characters_prompt: "How many characters?",
      generator_details_prompt: "Any details to add?",
      generator_details_placeholder: "Describe your universe\u2026",
      generator_record_cta: "Speak your universe",
      editor_ai_generate: "Generate Transmission",
      editor_ai_generating: "Transmitting Signal\u2026",
      editor_ai_mood_question: "What energy should this star radiate?",
      editor_ai_style_question: "What vision style for this transmission?",
      editor_ai_prompt_question: "Describe this star\u2019s landscape",
      editor_ai_accept: "Lock Transmission",
      editor_ai_reject: "Reject Signal",
      editor_ai_retry: "Retransmit",
      editor_ai_feedback_prompt: "How should we adjust the signal?",
      editor_ai_credit_cost: "1 Stardust per signal",
      spending_modal_title: "Refuel Your Mission",
      spending_modal_body: "You need more credits to continue. Choose how many to add.",
      spending_modal_no_payment: "Add a payment method to purchase credits.",
      spending_modal_credits_label: "Credits to add",
      spending_modal_price_label: "Total",
      spending_modal_admin_note: "Admin \u2014 credits are granted free of charge.",
      spending_modal_purchase: "Purchase Credits",
      spending_modal_grant: "Grant Credits",
      spending_modal_add_card: "Add Payment Method",
      spending_modal_card_last_four: "Card last four digits",
      spending_modal_card_label: "Card label (optional)",
      spending_modal_processing: "Processing\u2026",
      spending_modal_success: "Credits added.",
      spending_modal_error: "Could not complete purchase. Try again.",
      spending_modal_cancel: "Not now",
      spending_insufficient_credits: "Not enough credits. Purchase more to continue.",
      spending_add_credits_continue: "Add credits to continue",
      editor_ai_generating_scene: "Star forming\u2026",
      editor_ai_style_badge: "Signal Style",
      editor_ai_failed: "Signal lost. Try retransmitting.",
      editor_media_attached: "This star already has a transmission locked in.",
      editor_remove_media: "Remove Transmission",
      editor_media_question: "What's this scene's media?",
      editor_media_type_text: "Text",
      editor_media_type_imagery: "Imagery",
      editor_media_type_film: "Film",
      editor_media_preview_cta: "Preview",
      editor_media_preview_disabled: "Add text to enable preview.",
      editor_text_toolbar_label: "Text / Video",
      editor_text_font_label: "Font",
      editor_text_color_label: "Text Color",
      editor_text_background_label: "Background",
      editor_text_font_size_label: "Font Size",
      editor_text_placeholder: "Start writing scene media...",
      editor_line_add: "Add Text Block",
      editor_add_text: "Add Text",
      editor_add_video: "Add Video",
      editor_text_lines_section: "Transmission Lines",
      editor_line_editor_label: "Editor",
      editor_line_number: "Line",
      editor_select_line_hint: "Select a transmission line to edit",
      editor_select_effect_hint: "Select an effect to edit",
      editor_select_choice_hint: "Select a choice to edit",
      editor_line_timestamp: "Appears at",
      editor_line_fade_in: "Fade In",
      editor_line_fade_out: "Fade Out",
      editor_line_duration: "Duration",
      editor_line_persist: "Stay on Screen",
      editor_effects_section: "Effects",
      editor_effects_add: "Add sounds, effects, etc",
      editor_add_sound_music: "Add Sound / Music",
      editor_add_fx: "Add FX",
      editor_node_list_section: "Transmission Layers",
      editor_exit_choice_label: "Go To The End",
      editor_bg_layer_label: "Background",
      editor_remove_layer: "Remove",
      editor_new_node: "New\u2026",
      editor_new_text: "Lines of Text",
      editor_new_choice: "Choice",
      editor_new_image: "Image",
      editor_new_video: "Video",
      editor_new_music: "Music",
      editor_new_sound: "Sound Effect",
      editor_new_logic: "Logic",
      editor_new_credits: "Chosen by\u2026",
      editor_credits_layer: "Credits",
      editor_logic_mode_set: "Set Variable",
      editor_logic_mode_evaluate: "Evaluate",
      editor_logic_variable_label: "Variable",
      editor_logic_value_label: "Value",
      editor_logic_operator_label: "Condition",
      editor_logic_then_layers: "Then activate layers",
      editor_logic_new_variable: "New variable\u2026",
      editor_insert_star_menu: "Insert New Star\u2026",
      editor_select_node_hint: "Select a layer to edit",
      editor_effect_describe_prompt: "Describe what you want in detail",
      editor_effect_share_toggle: "Allow others to use this?",
      editor_effect_share_yes: "Yes, share with others",
      editor_effect_share_no: "No, keep it private",
      editor_effect_generating: "Generating\u2026",
      editor_effect_fade_in_sound: "Fade In Sound",
      editor_effect_fade_out_sound: "Fade Out Sound",
      editor_effect_fade_in_visual: "Fade In",
      editor_effect_fade_out_visual: "Fade Out",
      editor_timeline_label: "Timeline",
      editor_preview_label: "Preview",
      editor_preview_empty_hint: "Begin transmission",
      editor_preview_interact_hint: "Preview \u2014 drag transmission to position, resize from corner",
      editor_preview_play: "Play",
      editor_preview_pause: "Pause",
      editor_media_placeholder_imagery: "Imagery authoring is coming soon.",
      editor_media_placeholder_film: "Film authoring is coming soon.",
      editor_goto_scene: "Goto Star",
      editor_scene_duration: "Transmission Duration",
      editor_add_choice: "Add Choice",
      editor_arrow_tool: "Place Arrow",
      editor_goto_nullified: "Disabled \u2014 choices override goto",
      editor_remove_choice: "Remove Choice",
      editor_choice_target: "Destination Star",
      editor_choices_empty_hint: "Set a goto star or add a choice to branch the story.",
      editor_goto_none: "None",
      editor_choice_label: "Choice",
      editor_choice_display_label: "Signal Label",
      editor_choice_display_label_hint: "Leave blank to hide the label beneath the arrow. Lexicon keys like viewer_continue resolve to realm text.",
      editor_choice_display_label_empty: "No label",
      editor_choice_display_label_preview: "Preview",
      editor_choice_exit_target_hint: "Terminal exit \u2014 ends the story for viewers.",
      editor_flow_timeline: "Story Flow",
      editor_flow_goto_path: "Default Goto",
      editor_flow_add_choice_here: "Add Choice Here",
      editor_flow_choice_branch: "Branch",
      editor_flow_content_ref: "Content",
      editor_scene_duration_unit: "seconds",
      editor_scene_duration_override_hint: "Overrides transmission length. Signal runtime: {duration}s",
      editor_arrow_scale: "Span",
      editor_arrow_rotation: "Bearing",
      editor_arrow_rotate_hint: "Drag the beacon above the arrow in preview to rotate",
      constellation_no_coverbox: "Uncharted",
      hud_edit_control: "Engage",
      hud_delete_control: "Jettison",
      hud_publish_control: "Launch",
      hud_launch_control: "Launch",
      editor_publish_story: "Promote",
      viewer_loading: "Loading transmission\u2026",
      viewer_preparing: "Spooling media\u2026",
      viewer_close: "Exit",
      viewer_complete: "End Transmission",
      viewer_stage_label: "Viewport",
      viewer_choose_path: "Choose",
      viewer_scrub_label: "Playback position",
      create_button: "CREATE",
      publish_form_heading: "Launch readiness",
      tags_label: "Signal Tags",
      tags_placeholder: "Search signal tags\u2026",
      tags_empty: "No signal tags yet",
      tags_required: "At least one signal tag is required.",
      tags_clear: "Clear tag filter",
      all_nav_search_placeholder: "Scan transmissions\u2026",
      all_nav_sort_label: "Order by",
      all_nav_empty_nebula: "No transmissions",
      catalog_order_label: "Sort by",
      catalog_order_newest: "Newest Transmission",
      catalog_order_oldest: "Oldest Transmission",
      catalog_order_most_viewed: "Most viewed",
      catalog_order_least_viewed: "Least viewed",
      error_rate_limited: "Signal congestion. Wait a moment and try again.",
      story_picker_label: "Constellations",
      created_by: "Directed by",
      chosen_by: "Chosen by",
      story_metadata_heading: "Star system details",
      story_metadata_save: "Save",
      constellation_title_edit_hint: "Edit star system title and details",
      director_profile_title: "Director profile",
      director_profile_name_label: "Name",
      director_profile_realm_label: "Experience realm",
      director_profile_image_label: "Image",
      director_profile_image_hint: "Realm-themed seal \u2014 switching the realm above swaps the seal. Custom uploads land with the V1 avatar endpoints.",
      director_profile_tab_profile: "Profile",
      director_profile_tab_experience_mapping: "Experience Mapping",
      director_profile_admin_only: "Admin only",
      director_profile_cancel: "Cancel",
      director_profile_close: "Close",
      director_profile_save: "Save",
      director_profile_saving: "Saving\u2026",
      director_profile_name_required: "Name is required.",
      director_profile_username_locked_hint: "Call sign locked at enlistment \u2014 cannot be reassigned.",
      director_profile_save_failed: "Save failed",
      experience_mapping_loading: "Loading experience mapping\u2026",
      experience_mapping_empty: "No template hierarchy available yet.",
      experience_mapping_retry: "Retry",
      experience_mapping_story_label: "Star System",
      experience_mapping_scene_label: "Star",
      experience_mapping_action_label: "Action",
      experience_mapping_field_title: "Title",
      experience_mapping_field_description: "Description",
      experience_mapping_field_genre: "Genre",
      experience_mapping_field_content_rating: "Content rating",
      experience_mapping_field_color: "Color",
      experience_mapping_field_name: "Name",
      experience_mapping_field_type: "Type",
      experience_mapping_field_order: "Order",
      experience_mapping_field_duration: "Duration",
      experience_mapping_field_properties: "Properties",
      experience_mapping_field_subproperties: "Subproperties",
      experience_mapping_save_changes: "Save changes",
      experience_mapping_saved: "Saved",
      experience_mapping_save_error: "Could not save changes.",
      experience_mapping_delete_story: "Delete star system",
      experience_mapping_delete_scene: "Delete star",
      experience_mapping_delete_action: "Delete action",
      experience_mapping_delete_confirm: "Click again to confirm",
      experience_mapping_delete_error: "Delete failed.",
      experience_mapping_expand_all: "Expand all",
      experience_mapping_collapse_all: "Collapse all",
      experience_mapping_forbidden: "You do not have admin access for this section.",
      experience_mapping_bad_json: "JSON must be valid before saving.",
      experience_mapping_intro: "Edit realm vocabulary from largest to smallest. Generate JSON and paste it in chat for code application.",
      experience_mapping_dirty: "dirty changes",
      experience_mapping_export_ready: "No unsaved mapping edits yet.",
      experience_mapping_export_json: "Generate JSON export",
      experience_mapping_copy_json: "Copy JSON",
      experience_mapping_copied: "Copied",
      experience_mapping_paste_instruction: "Paste this JSON in chat and I will apply it to chuzi-shared.",
      experience_mapping_export_empty: "Export output appears here.",
      experience_mapping_select_realm: "Select realm",
      experience_mapping_group_major_idea: "Major Idea",
      experience_mapping_helper_realm_idea: "Highest-level concept for this realm.",
      experience_mapping_save_experience: "Save to experience",
      experience_mapping_saved_experience: "Saved to current experience. Some labels appear immediately.",
      auth_email_placeholder: "Email",
      auth_password_input_placeholder: "Password",
      auth_password_sign_in_button: "Sign In",
      auth_password_signing_in: "Signing in...",
      auth_signin_tab: "Sign in",
      auth_signup_tab: "Sign up",
      auth_signup_subtitle: "Create your account with secure sign-in.",
      auth_signin_subtitle: "Sign in with your username or email.",
      auth_sign_up_button: "Create account",
      auth_username_placeholder: "Username",
      auth_identifier_placeholder: "Username or email",
      auth_sign_in_button: "Log in",
      auth_continue_with_google: "Continue with Google",
      auth_magic_link_code_placeholder: "Sign-in code",
      auth_magic_link_enter_code: "Enter the code from your email to sign in.",
      auth_magic_link_sent_code: "Check your email for your sign-in code.",
      auth_code_required: "Sign-in code is required.",
      auth_identifier_required: "Username or email is required.",
      auth_identifier_not_found: "No account found with that username.",
      auth_signing_in: "Signing in...",
      auth_oidc_redirecting: "Redirecting to secure sign-in...",
      auth_oidc_failed: "Could not start sign-in.",
      auth_oidc_callback_processing: "Completing sign-in...",
      auth_oidc_verified: "Signed in. Redirecting...",
      auth_oidc_callback_failed: "Could not complete sign-in.",
      auth_oidc_token_missing: "Sign-in token was missing.",
      auth_magic_link_sent: "If that email is registered, a magic link has been sent.",
      auth_magic_link_sent_signup: "Check your email for your sign-up link.",
      auth_magic_link_verifying: "Verifying magic link...",
      auth_magic_link_verified: "Signed in. Redirecting...",
      auth_magic_link_failed: "This magic link is invalid or expired.",
      auth_magic_link_cta: "Use another email",
      auth_login_failed: "Sign-in failed.",
      auth_username_checking: "Checking username availability...",
      auth_username_available: "Username is available.",
      auth_username_unavailable: "Username is taken; updated to an available suggestion.",
      auth_username_required: "Username is required.",
      auth_username_update_failed: "Could not reserve a unique username.",
      experience_mapping_group_experience_root: "Experience Root",
      experience_mapping_group_node_types: "Node Types",
      experience_mapping_group_scene_structure: "Scene Structure",
      experience_mapping_group_media: "Media Terms",
      experience_mapping_group_counts: "Counts and Adjacent Labels",
      experience_mapping_helper_story: "Largest narrative unit.",
      experience_mapping_helper_scene: "Contained unit under story.",
      experience_mapping_helper_scene_choice: "Branching choice in a scene.",
      experience_mapping_helper_node: "Smallest flow node.",
      experience_mapping_helper_alt_media: "Smallest related media label."
    },
    locales: {
      es: {
        genre: "Galaxia",
        story: "Sistema Estelar",
        scene: "Estrella",
        scene_choice: "Elecci\xF3n",
        player: "Viajero",
        library: "Carta Estelar",
        editor: "Control de Misi\xF3n",
        publish: "Lanzar",
        the_end: "\xD3rbita Final",
        untitled_story: "Sistema Estelar sin t\xEDtulo",
        menu_create_story: "Nuevo sistema estelar",
        film_title_placeholder: "T\xEDtulo del sistema estelar",
        select_genre: "Seleccionar galaxia",
        created_by: "Dirigido por"
      },
      fr: {
        genre: "Galaxie",
        story: "Syst\xE8me Stellaire",
        scene: "\xC9toile",
        scene_choice: "Choix",
        player: "Voyageur",
        library: "Carte Stellaire",
        editor: "Contr\xF4le de Mission",
        publish: "Lancer",
        the_end: "Orbite Finale",
        untitled_story: "Syst\xE8me stellaire sans titre",
        menu_create_story: "Nouveau syst\xE8me stellaire",
        film_title_placeholder: "Titre du syst\xE8me stellaire",
        select_genre: "S\xE9lectionner une galaxie",
        created_by: "R\xE9alis\xE9 par"
      },
      de: {
        genre: "Galaxie",
        story: "Sternsystem",
        scene: "Stern",
        player: "Reisender",
        publish: "Starten"
      },
      pt: {
        genre: "Gal\xE1xia",
        story: "Sistema Estelar",
        scene: "Estrela",
        player: "Viajante",
        publish: "Lan\xE7ar"
      }
    }
  },
  wilds: {
    label: "CHUZI WILDS",
    short_label: "Wilds",
    lexicon: {
      genre: "Biome",
      story: "Grove",
      scene: "Clearing",
      scene_choice: "Trail",
      node: "Seed",
      node_type_choice: "Trail",
      node_type_media: "Bloom",
      node_type_go_to_scene: "Crossing",
      player: "Wanderer",
      library: "Canopy",
      library_open: "Open Canopy",
      library_close: "Close Canopy",
      editor: "Heartwood",
      publish: "Plant",
      experience_realm_idea: "Untamed Nature",
      the_end: "Roots",
      // deprecated — no longer generated
      media_pool: "Undergrowth",
      scene_graph: "Canopy",
      watch_path: "Your trail",
      untitled_story: "Untitled Grove",
      untitled_scene: "Untitled Branch",
      unknown_genre: "Unknown Biome",
      scenes_count: "clearings",
      choices_count: "trails",
      drafts_published: "Drafts + Planted",
      published_ver: "Planted ver.",
      draft: "Draft",
      no_scenes_yet: "No clearings in this canopy yet.",
      no_path_yet: "No trail to show yet.",
      menu_empty_drafts: "No groves yet. Plant one to begin.",
      menu_empty_published: "No planted groves in the canopy.",
      menu_published_heading: "Planted groves",
      menu_create_story: "New grove",
      menu_create_film: "Create film",
      film_title_placeholder: "Grove title",
      select_genre: "Select biome",
      genre_field_aria: "Biome",
      delete_story_verb: "Delete grove",
      title_scene_default: "Trailhead",
      choices_made_stat: "trails taken",
      content_rating: "Field Guide",
      content_rating_field_aria: "Field guide",
      select_content_rating: "Select field guide",
      unrated: "Unmarked",
      viewer_credits: "Sap",
      creator_credits: "Pollen",
      editor_media_upload: "Upload Bloom",
      editor_media_preview: "Bloom Preview",
      editor_alt_media: "Effects",
      editor_choices: "Choices",
      editor_scene_settings: "Clearing Settings",
      editor_scene_type_label: "Clearing",
      editor_title_scene: "Start",
      editor_film_title: "Grove Title",
      editor_film_title_hint: "Click to rename this grove",
      editor_ending_scene: "End",
      editor_play: "Unfurl",
      editor_pause: "Rest",
      editor_prev_frame: "Previous Frame",
      editor_next_frame: "Next Frame",
      editor_seek: "Seek",
      editor_no_media: "No bloom assigned",
      editor_uploading: "Blooming\u2026",
      editor_drop_media: "Drop bloom here",
      editor_scene_type: "Clearing Type",
      editor_save: "Engrave",
      editor_cancel: "Cancel",
      editor_create_scene: "Plant Clearing",
      editor_create_scene_plain: "Create New Scene",
      editor_create_scene_before: "Insert New Clearing Before",
      editor_create_scene_after: "Insert New Clearing After",
      editor_create_scene_ahead: "Plant Next Clearing",
      editor_create_next_scene: "Grow Next Branch",
      editor_create_scene_cost: "1 Pollen",
      editor_delete_scene_cta: "Delete Scene",
      editor_delete_scene_confirm: "Click again to confirm",
      editor_scene_locked_delete: "Start scene cannot be deleted.",
      editor_scene_color: "Clearing Tint",
      viewer_continue: "Press On",
      chuzi_ai_name: "Chuzi AI",
      chuzi_ai_create_with: "Create with Chuzi AI",
      chuzi_ai_create_manual: "Enter title manually",
      chuzi_ai_intro: "Answer a few story prompts and Chuzi AI will grow your short story.",
      chuzi_ai_step_of: "Step",
      chuzi_ai_back: "Back",
      chuzi_ai_next: "Next",
      chuzi_ai_scenes_label: "scenes",
      chuzi_ai_creating: "Creating\u2026",
      chuzi_ai_generate_failed: "Story generation failed.",
      chuzi_ai_build_failed: "Failed to build story.",
      chuzi_ai_generate: "Generate scene",
      chuzi_ai_generating: "Generating\u2026",
      chuzi_ai_token_in: "Tokens in",
      chuzi_ai_token_out: "Tokens out",
      chuzi_ai_credits_cost: "AI credits",
      chuzi_ai_scene_credits: "Scene credits",
      chuzi_ai_total_cost: "Total create credits",
      chuzi_ai_insufficient: "Not enough create credits for this generation.",
      chuzi_ai_apply: "Build story",
      chuzi_ai_applying: "Building scenes\u2026",
      chuzi_ai_scene_create: "Create scene with Chuzi AI",
      chuzi_ai_scene_overwrite: "Rewrite scene with Chuzi AI",
      chuzi_ai_scene_brief: "Scene direction",
      chuzi_ai_scene_brief_hint: "Describe what should happen in this scene. Chuzi AI reads your existing story for characters, tone, and style.",
      chuzi_ai_scene_context_note: "Uses your story\u2019s existing scenes, typography, and art direction as context.",
      chuzi_ai_scene_overwrite_confirm: "I understand this replaces this scene\u2019s text and styling.",
      chuzi_ai_scene_apply_create: "Create scene",
      chuzi_ai_scene_apply_overwrite: "Replace scene",
      chuzi_ai_scene_continue_default: "Continue the story with the next scene. Leave the narrative open-ended.",
      chuzi_ai_scene_continue_vibes: "Stay in the same tone and genre ({vibes}).",
      chuzi_ai_scene_continue_characters: "Keep roughly {count} characters in play.",
      chuzi_ai_scene_continue_hook: "Write the next scene continuing from where the story left off. Do not end or resolve the story.",
      editor_scene_nav: "Scene navigation",
      editor_scene_title_hint: "Click to rename this clearing",
      chuzi_ai_step_protagonist_hint: "Who is your main character? Name, age, personality, and what makes them interesting.",
      chuzi_ai_step_setting: "Setting",
      chuzi_ai_step_setting_hint: "Where and when does the story begin? Describe the world and their everyday life.",
      chuzi_ai_step_conflict: "Conflict",
      chuzi_ai_step_conflict_hint: "What event or problem kicks the story into motion?",
      chuzi_ai_step_journey: "Journey",
      chuzi_ai_step_journey_hint: "What challenges, turning points, climax, and resolution shape the story?",
      chuzi_ai_step_tone: "Tone & mood",
      chuzi_ai_step_tone_hint: "Genre, mood, and atmosphere (e.g. bittersweet sci-fi, cozy mystery, epic fantasy).",
      chuzi_ai_monomyth_hero: "Hero\u2019s Journey: the protagonist",
      chuzi_ai_monomyth_world: "Monomyth: ordinary world",
      chuzi_ai_monomyth_you: "Story Circle: zone of comfort",
      chuzi_ai_monomyth_need: "Story Circle: something isn\u2019t right",
      chuzi_ai_monomyth_go: "Monomyth: crossing the first threshold",
      chuzi_ai_monomyth_search: "Monomyth: road of trials",
      chuzi_ai_monomyth_find: "Monomyth: the ultimate boon",
      chuzi_ai_monomyth_take: "Monomyth: atonement with the father",
      chuzi_ai_monomyth_return: "Monomyth: crossing the return threshold",
      chuzi_ai_monomyth_change: "Monomyth: freedom to live",
      cosmos_cluster_published: "Ancient Grove",
      cosmos_cluster_unpublished: "Seedling Nursery",
      cosmos_cluster_limited: "Canopy Clearing",
      cosmos_cluster_jettisoned: "Deadfall",
      jettison_unjettison: "Regrow",
      jettison_promote: "Return to Heartwood",
      jettison_purge_story: "Burn",
      jettison_purge_all: "Burn All",
      jettison_days_remaining: "{days}d remaining",
      nav_bar_empty_nebula: "No groves",
      nebula_chuzi: "CHUZI!",
      published_version_label: "Version",
      system_story_create: "New reserved story",
      publish_tier_private: "Private",
      publish_tier_limited: "Limited access",
      publish_tier_worldwide: "Worldwide",
      hud_unpublish_control: "Uproot",
      hud_retract_control: "Retract",
      unpublish_confirm_hint: "Tap again to confirm",
      create_publish_hint: "Add ratings, genre & coverbox when you bloom.",
      generator_create_upload: "Create / Upload Bloom",
      generator_generate: "Generate with Chuzi AI",
      generator_vibes_prompt: "Choose your vibes",
      generator_vibes_required: "Pick at least one vibe.",
      generator_audience_prompt: "Who\u2019s your audience?",
      generator_audience_placeholder: "Select reading level",
      generator_characters_prompt: "How many characters?",
      generator_details_prompt: "Any details to add?",
      generator_details_placeholder: "Describe your world\u2026",
      generator_record_cta: "Whisper your world",
      editor_ai_generate: "Grow Bloom",
      editor_ai_generating: "Seed Sprouting\u2026",
      editor_ai_mood_question: "What feeling should this clearing evoke?",
      editor_ai_style_question: "What growth pattern for this bloom?",
      editor_ai_prompt_question: "Describe this clearing",
      editor_ai_accept: "Root Bloom",
      editor_ai_reject: "Prune Bloom",
      editor_ai_retry: "Regrow",
      editor_ai_feedback_prompt: "How should we reshape the growth?",
      editor_ai_credit_cost: "1 Pollen per bloom",
      spending_modal_title: "Gather More Pollen",
      spending_modal_body: "You need more credits to continue. Choose how many to add.",
      spending_modal_no_payment: "Add a payment method to purchase credits.",
      spending_modal_credits_label: "Credits to add",
      spending_modal_price_label: "Total",
      spending_modal_admin_note: "Admin \u2014 credits are granted free of charge.",
      spending_modal_purchase: "Purchase Credits",
      spending_modal_grant: "Grant Credits",
      spending_modal_add_card: "Add Payment Method",
      spending_modal_card_last_four: "Card last four digits",
      spending_modal_card_label: "Card label (optional)",
      spending_modal_processing: "Processing\u2026",
      spending_modal_success: "Credits added.",
      spending_modal_error: "Could not complete purchase. Try again.",
      spending_modal_cancel: "Not now",
      spending_insufficient_credits: "Not enough credits. Purchase more to continue.",
      spending_add_credits_continue: "Add credits to continue",
      editor_ai_generating_scene: "Clearing emerging\u2026",
      editor_ai_style_badge: "Growth Style",
      editor_ai_failed: "Growth withered. Try regrowing.",
      editor_media_attached: "This clearing already has a bloom rooted.",
      editor_remove_media: "Uproot Bloom",
      editor_media_question: "What's this scene's media?",
      editor_media_type_text: "Text",
      editor_media_type_imagery: "Imagery",
      editor_media_type_film: "Film",
      editor_media_preview_cta: "Preview",
      editor_media_preview_disabled: "Add text to enable preview.",
      editor_text_toolbar_label: "Text / Video",
      editor_text_font_label: "Font",
      editor_text_color_label: "Text Color",
      editor_text_background_label: "Background",
      editor_text_font_size_label: "Font Size",
      editor_text_placeholder: "Start writing scene media...",
      editor_line_add: "Add Text Block",
      editor_add_text: "Add Text",
      editor_add_video: "Add Video",
      editor_text_lines_section: "Transmission Lines",
      editor_line_editor_label: "Editor",
      editor_line_number: "Line",
      editor_select_line_hint: "Select a transmission line to edit",
      editor_select_effect_hint: "Select an effect to edit",
      editor_select_choice_hint: "Select a choice to edit",
      editor_line_timestamp: "Appears at",
      editor_line_fade_in: "Fade In",
      editor_line_fade_out: "Fade Out",
      editor_line_duration: "Duration",
      editor_line_persist: "Stay on Screen",
      editor_effects_section: "Effects",
      editor_effects_add: "Add sounds, effects, etc",
      editor_add_sound_music: "Add Sound / Music",
      editor_add_fx: "Add FX",
      editor_node_list_section: "Bloom Layers",
      editor_exit_choice_label: "Go To The End",
      editor_bg_layer_label: "Background",
      editor_remove_layer: "Remove",
      editor_new_node: "New\u2026",
      editor_new_text: "Lines of Text",
      editor_new_choice: "Trail",
      editor_new_image: "Image",
      editor_new_video: "Video",
      editor_new_music: "Music",
      editor_new_sound: "Sound Effect",
      editor_new_logic: "Logic",
      editor_new_credits: "Chosen by\u2026",
      editor_credits_layer: "Credits",
      editor_logic_mode_set: "Set Variable",
      editor_logic_mode_evaluate: "Evaluate",
      editor_logic_variable_label: "Variable",
      editor_logic_value_label: "Value",
      editor_logic_operator_label: "Condition",
      editor_logic_then_layers: "Then activate layers",
      editor_logic_new_variable: "New variable\u2026",
      editor_insert_star_menu: "Insert New Clearing\u2026",
      editor_select_node_hint: "Select a layer to edit",
      editor_effect_describe_prompt: "Describe what you want in detail",
      editor_effect_share_toggle: "Allow others to use this?",
      editor_effect_share_yes: "Yes, share with others",
      editor_effect_share_no: "No, keep it private",
      editor_effect_generating: "Generating\u2026",
      editor_effect_fade_in_sound: "Fade In Sound",
      editor_effect_fade_out_sound: "Fade Out Sound",
      editor_effect_fade_in_visual: "Fade In",
      editor_effect_fade_out_visual: "Fade Out",
      editor_timeline_label: "Timeline",
      editor_preview_label: "Preview",
      editor_preview_empty_hint: "Await the bloom",
      editor_preview_interact_hint: "Preview \u2014 drag bloom to position, resize from corner",
      editor_preview_play: "Play",
      editor_preview_pause: "Pause",
      editor_media_placeholder_imagery: "Imagery authoring is coming soon.",
      editor_media_placeholder_film: "Film authoring is coming soon.",
      editor_goto_scene: "Goto Clearing",
      editor_scene_duration: "Bloom Duration",
      editor_add_choice: "Add Trail",
      editor_arrow_tool: "Place Indicator",
      editor_goto_nullified: "Disabled \u2014 trails override goto",
      editor_remove_choice: "Remove Trail",
      editor_choice_target: "Destination Clearing",
      editor_choices_empty_hint: "Set a goto clearing or add a trail to branch the story.",
      editor_goto_none: "None",
      editor_choice_label: "Trail",
      editor_choice_display_label: "Trail Label",
      editor_choice_display_label_hint: "Leave blank to hide the label beneath the indicator. Lexicon keys like viewer_continue resolve to realm text.",
      editor_choice_display_label_empty: "No label",
      editor_choice_display_label_preview: "Preview",
      editor_choice_exit_target_hint: "Terminal exit \u2014 ends the story for viewers.",
      editor_flow_timeline: "Story Flow",
      editor_flow_goto_path: "Default Goto",
      editor_flow_add_choice_here: "Add Trail Here",
      editor_flow_choice_branch: "Branch",
      editor_flow_content_ref: "Content",
      editor_scene_duration_unit: "seconds",
      editor_scene_duration_override_hint: "Overrides bloom length. Content runtime: {duration}s",
      editor_arrow_scale: "Span",
      editor_arrow_rotation: "Bearing",
      editor_arrow_rotate_hint: "Drag the beacon above the indicator in preview to rotate",
      constellation_no_coverbox: "Unseen",
      hud_edit_control: "Tend",
      hud_delete_control: "Uproot",
      hud_publish_control: "Plant",
      hud_launch_control: "Enter",
      editor_publish_story: "Share",
      viewer_loading: "Entering the grove\u2026",
      viewer_preparing: "Gathering blooms\u2026",
      viewer_close: "Leave",
      viewer_complete: "End Journey",
      viewer_stage_label: "Canopy",
      viewer_choose_path: "Choose",
      viewer_scrub_label: "Playback position",
      create_button: "CREATE",
      publish_form_heading: "Planting check",
      tags_label: "Root Tags",
      tags_placeholder: "Search root tags\u2026",
      tags_empty: "No root tags yet",
      tags_required: "At least one root tag is required.",
      tags_clear: "Clear tag filter",
      all_nav_search_placeholder: "Seek trails\u2026",
      all_nav_sort_label: "Order by",
      all_nav_empty_nebula: "No groves",
      catalog_order_label: "Sort by",
      catalog_order_newest: "Newest Sprout",
      catalog_order_oldest: "Oldest Sprout",
      catalog_order_most_viewed: "Most viewed",
      catalog_order_least_viewed: "Least viewed",
      error_rate_limited: "The grove needs a breath. Wait a moment and try again.",
      story_picker_label: "Groves",
      created_by: "Tended by",
      chosen_by: "Chosen by",
      story_metadata_heading: "Grove details",
      story_metadata_save: "Save",
      constellation_title_edit_hint: "Edit grove title and details",
      director_profile_title: "Director profile",
      director_profile_name_label: "Name",
      director_profile_realm_label: "Experience realm",
      director_profile_image_label: "Image",
      director_profile_image_hint: "Realm-themed seal \u2014 switching the realm above swaps the seal. Custom uploads land with the V1 avatar endpoints.",
      director_profile_tab_profile: "Profile",
      director_profile_tab_experience_mapping: "Experience Mapping",
      director_profile_admin_only: "Admin only",
      director_profile_cancel: "Cancel",
      director_profile_close: "Close",
      director_profile_save: "Save",
      director_profile_saving: "Saving\u2026",
      director_profile_name_required: "Name is required.",
      director_profile_username_locked_hint: "Trail name set at first bloom \u2014 cannot be changed.",
      director_profile_save_failed: "Save failed",
      experience_mapping_loading: "Loading experience mapping\u2026",
      experience_mapping_empty: "No template hierarchy available yet.",
      experience_mapping_retry: "Retry",
      experience_mapping_story_label: "Story",
      experience_mapping_scene_label: "Scene",
      experience_mapping_action_label: "Action",
      experience_mapping_field_title: "Title",
      experience_mapping_field_description: "Description",
      experience_mapping_field_genre: "Genre",
      experience_mapping_field_content_rating: "Content rating",
      experience_mapping_field_color: "Color",
      experience_mapping_field_name: "Name",
      experience_mapping_field_type: "Type",
      experience_mapping_field_order: "Order",
      experience_mapping_field_duration: "Duration",
      experience_mapping_field_properties: "Properties",
      experience_mapping_field_subproperties: "Subproperties",
      experience_mapping_save_changes: "Save changes",
      experience_mapping_saved: "Saved",
      experience_mapping_save_error: "Could not save changes.",
      experience_mapping_delete_story: "Delete story",
      experience_mapping_delete_scene: "Delete scene",
      experience_mapping_delete_action: "Delete action",
      experience_mapping_delete_confirm: "Click again to confirm",
      experience_mapping_delete_error: "Delete failed.",
      experience_mapping_expand_all: "Expand all",
      experience_mapping_collapse_all: "Collapse all",
      experience_mapping_forbidden: "You do not have admin access for this section.",
      experience_mapping_bad_json: "JSON must be valid before saving.",
      experience_mapping_intro: "Edit realm vocabulary from largest to smallest. Generate JSON and paste it in chat for code application.",
      experience_mapping_dirty: "dirty changes",
      experience_mapping_export_ready: "No unsaved mapping edits yet.",
      experience_mapping_export_json: "Generate JSON export",
      experience_mapping_copy_json: "Copy JSON",
      experience_mapping_copied: "Copied",
      experience_mapping_paste_instruction: "Paste this JSON in chat and I will apply it to chuzi-shared.",
      experience_mapping_export_empty: "Export output appears here.",
      experience_mapping_select_realm: "Select realm",
      experience_mapping_group_major_idea: "Major Idea",
      experience_mapping_helper_realm_idea: "Highest-level concept for this realm.",
      experience_mapping_save_experience: "Save to experience",
      experience_mapping_saved_experience: "Saved to current experience. Some labels appear immediately.",
      auth_email_placeholder: "Email",
      auth_password_input_placeholder: "Password",
      auth_password_sign_in_button: "Sign In",
      auth_password_signing_in: "Signing in...",
      auth_signin_tab: "Sign in",
      auth_signup_tab: "Sign up",
      auth_signup_subtitle: "Create your account with secure sign-in.",
      auth_signin_subtitle: "Sign in with your username or email.",
      auth_sign_up_button: "Create account",
      auth_username_placeholder: "Username",
      auth_identifier_placeholder: "Username or email",
      auth_sign_in_button: "Log in",
      auth_continue_with_google: "Continue with Google",
      auth_magic_link_code_placeholder: "Sign-in code",
      auth_magic_link_enter_code: "Enter the code from your email to sign in.",
      auth_magic_link_sent_code: "Check your email for your sign-in code.",
      auth_code_required: "Sign-in code is required.",
      auth_identifier_required: "Username or email is required.",
      auth_identifier_not_found: "No account found with that username.",
      auth_signing_in: "Signing in...",
      auth_oidc_redirecting: "Redirecting to secure sign-in...",
      auth_oidc_failed: "Could not start sign-in.",
      auth_oidc_callback_processing: "Completing sign-in...",
      auth_oidc_verified: "Signed in. Redirecting...",
      auth_oidc_callback_failed: "Could not complete sign-in.",
      auth_oidc_token_missing: "Sign-in token was missing.",
      auth_magic_link_sent: "If that email is registered, a magic link has been sent.",
      auth_magic_link_sent_signup: "Check your email for your sign-up link.",
      auth_magic_link_verifying: "Verifying magic link...",
      auth_magic_link_verified: "Signed in. Redirecting...",
      auth_magic_link_failed: "This magic link is invalid or expired.",
      auth_magic_link_cta: "Use another email",
      auth_login_failed: "Sign-in failed.",
      auth_username_checking: "Checking username availability...",
      auth_username_available: "Username is available.",
      auth_username_unavailable: "Username is taken; updated to an available suggestion.",
      auth_username_required: "Username is required.",
      auth_username_update_failed: "Could not reserve a unique username.",
      experience_mapping_group_experience_root: "Experience Root",
      experience_mapping_group_node_types: "Node Types",
      experience_mapping_group_scene_structure: "Scene Structure",
      experience_mapping_group_media: "Media Terms",
      experience_mapping_group_counts: "Counts and Adjacent Labels",
      experience_mapping_helper_story: "Largest narrative unit.",
      experience_mapping_helper_scene: "Contained unit under story.",
      experience_mapping_helper_scene_choice: "Branching choice in a scene.",
      experience_mapping_helper_node: "Smallest flow node.",
      experience_mapping_helper_alt_media: "Smallest related media label."
    },
    locales: {
      es: {
        genre: "Bioma",
        story: "Arboleda",
        scene: "Claro",
        scene_choice: "Sendero",
        player: "Errante",
        library: "Dosel",
        editor: "Duramen",
        publish: "Plantar",
        the_end: "Ra\xEDces",
        untitled_story: "Arboleda sin t\xEDtulo",
        menu_create_story: "Nueva arboleda",
        film_title_placeholder: "T\xEDtulo de la arboleda",
        select_genre: "Seleccionar bioma",
        created_by: "Cuidado por"
      },
      fr: {
        genre: "Biome",
        story: "Bosquet",
        scene: "Clairi\xE8re",
        scene_choice: "Sentier",
        player: "Vagabond",
        library: "Canop\xE9e",
        editor: "C\u0153ur de bois",
        publish: "Planter",
        the_end: "Racines",
        untitled_story: "Bosquet sans titre",
        menu_create_story: "Nouveau bosquet",
        film_title_placeholder: "Titre du bosquet",
        select_genre: "S\xE9lectionner un biome",
        created_by: "Soign\xE9 par"
      },
      de: {
        genre: "Biom",
        story: "Hain",
        scene: "Lichtung",
        player: "Wanderer",
        publish: "Pflanzen"
      },
      pt: {
        genre: "Bioma",
        story: "Bosque",
        scene: "Clareira",
        player: "Andarilho",
        publish: "Plantar"
      }
    }
  }
};
var FALLBACK_LEXICON = {
  genre: "Genre",
  story: "Story",
  scene: "Scene",
  scene_choice: "Choice",
  node: "Node",
  node_type_choice: "Choice",
  node_type_media: "Media",
  node_type_go_to_scene: "Go to scene",
  player: "Player",
  library: "Library",
  library_open: "Open scene tree",
  library_close: "Close scene tree",
  editor: "Editor",
  publish: "Publish",
  experience_realm_idea: "Experience Theme",
  the_end: "The End",
  // deprecated — no longer generated
  media_pool: "Media Pool",
  scene_graph: "Scene tree",
  watch_path: "Your path",
  untitled_story: "Untitled Story",
  untitled_scene: "Untitled Scene",
  unknown_genre: "Unknown Genre",
  scenes_count: "scenes",
  choices_count: "choices",
  drafts_published: "Drafts + Published",
  published_ver: "Published ver.",
  draft: "Draft",
  no_scenes_yet: "No scenes available yet.",
  no_path_yet: "No path to show yet.",
  menu_empty_drafts: "No films yet. Create one to get started.",
  menu_empty_published: "No published films found.",
  menu_published_heading: "Published Films",
  menu_create_story: "Create Story",
  menu_create_film: "Create Film",
  film_title_placeholder: "Film title",
  select_genre: "Select genre",
  genre_field_aria: "Film genre",
  delete_story_verb: "Delete film",
  title_scene_default: "Start",
  choices_made_stat: "choices made",
  content_rating: "Rating",
  content_rating_field_aria: "Content rating",
  select_content_rating: "Select rating",
  unrated: "Not Rated",
  viewer_credits: "Viewer Credits",
  creator_credits: "Creator Credits",
  editor_media_upload: "Upload Media",
  editor_media_preview: "Media Preview",
  editor_alt_media: "Effects",
  editor_choices: "Choices",
  editor_scene_settings: "Scene Settings",
  editor_scene_type_label: "Scene",
  editor_title_scene: "Start",
  editor_film_title: "Film Title",
  editor_film_title_hint: "Click to rename this film",
  editor_ending_scene: "End",
  editor_play: "Play",
  editor_pause: "Pause",
  editor_prev_frame: "Previous Frame",
  editor_next_frame: "Next Frame",
  editor_seek: "Seek",
  editor_no_media: "No media assigned",
  editor_uploading: "Uploading\u2026",
  editor_drop_media: "Drop media here",
  editor_scene_type: "Scene Type",
  editor_save: "Save",
  editor_cancel: "Cancel",
  editor_create_scene: "Create Scene",
  editor_create_scene_plain: "Create New Scene",
  editor_create_scene_before: "Insert new scene before",
  editor_create_scene_after: "Insert new scene after",
  editor_create_scene_ahead: "Create new scene",
  editor_create_next_scene: "Create next scene",
  editor_create_scene_cost: "1 credit",
  editor_delete_scene_cta: "Delete Scene",
  editor_delete_scene_confirm: "Click again to confirm",
  editor_scene_locked_delete: "Start scene cannot be deleted.",
  editor_scene_color: "Scene Color",
  chuzi_ai_name: "Chuzi AI",
  chuzi_ai_create_with: "Create with Chuzi AI",
  chuzi_ai_create_manual: "Enter title manually",
  chuzi_ai_intro: "Answer a few story prompts and Chuzi AI will draft your short story.",
  chuzi_ai_step_of: "Step",
  chuzi_ai_back: "Back",
  chuzi_ai_next: "Next",
  chuzi_ai_scenes_label: "scenes",
  chuzi_ai_creating: "Creating\u2026",
  chuzi_ai_generate_failed: "Story generation failed.",
  chuzi_ai_build_failed: "Failed to build story.",
  chuzi_ai_generate: "Generate scene",
  chuzi_ai_generating: "Generating\u2026",
  chuzi_ai_token_in: "Tokens in",
  chuzi_ai_token_out: "Tokens out",
  chuzi_ai_credits_cost: "AI credits",
  chuzi_ai_scene_credits: "Scene credits",
  chuzi_ai_total_cost: "Total create credits",
  chuzi_ai_insufficient: "Not enough create credits for this generation.",
  chuzi_ai_apply: "Build story",
  chuzi_ai_applying: "Building scenes\u2026",
  wizard_back: "Back",
  wizard_next: "Next",
  wizard_vibes_hint: "Pick the genres and moods for your scene. Select multiple.",
  wizard_audience_hint: "Controls vocabulary, sentence length, and themes.",
  wizard_details_placeholder: "What happens next?",
  chuzi_ai_scene_create: "Create scene with Chuzi AI",
  chuzi_ai_scene_overwrite: "Rewrite scene with Chuzi AI",
  chuzi_ai_scene_brief: "Scene direction",
  chuzi_ai_scene_brief_hint: "Describe what should happen in this scene. Chuzi AI reads your existing story for characters, tone, and style.",
  chuzi_ai_scene_context_note: "Uses your story\u2019s existing scenes, typography, and art direction as context.",
  chuzi_ai_scene_overwrite_confirm: "I understand this replaces this scene\u2019s text and styling.",
  chuzi_ai_scene_apply_create: "Create scene",
  chuzi_ai_scene_apply_overwrite: "Replace scene",
  chuzi_ai_scene_continue_default: "Continue the story with the next scene. Leave the narrative open-ended.",
  chuzi_ai_scene_continue_vibes: "Stay in the same tone and genre ({vibes}).",
  chuzi_ai_scene_continue_characters: "Keep roughly {count} characters in play.",
  chuzi_ai_scene_continue_hook: "Write the next scene continuing from where the story left off. Do not end or resolve the story.",
  editor_scene_nav: "Scene navigation",
  editor_scene_title_hint: "Click to rename this scene",
  chuzi_ai_step_protagonist: "Protagonist",
  chuzi_ai_step_protagonist_hint: "Who is your main character? Name, age, personality, and what makes them interesting.",
  chuzi_ai_step_setting: "Setting",
  chuzi_ai_step_setting_hint: "Where and when does the story begin? Describe the world and their everyday life.",
  chuzi_ai_step_conflict: "Conflict",
  chuzi_ai_step_conflict_hint: "What event or problem kicks the story into motion?",
  chuzi_ai_step_journey: "Journey",
  chuzi_ai_step_journey_hint: "What challenges, turning points, climax, and resolution shape the story?",
  chuzi_ai_step_tone: "Tone & mood",
  chuzi_ai_step_tone_hint: "Genre, mood, and atmosphere (e.g. bittersweet sci-fi, cozy mystery, epic fantasy).",
  viewer_continue: "Continue",
  cosmos_cluster_published: "Published",
  cosmos_cluster_unpublished: "Unpublished",
  cosmos_cluster_limited: "Limited",
  cosmos_cluster_jettisoned: "Jettisoned",
  jettison_unjettison: "Recover",
  jettison_promote: "Promote",
  jettison_purge_story: "Delete Permanently",
  jettison_purge_all: "Purge All",
  jettison_days_remaining: "{days}d remaining",
  nav_bar_empty_nebula: "No stories",
  nebula_chuzi: "CHUZI!",
  published_version_label: "Version",
  system_story_create: "New reserved story",
  publish_tier_private: "Private",
  publish_tier_limited: "Limited access",
  publish_tier_worldwide: "Worldwide",
  hud_unpublish_control: "Unpublish",
  hud_retract_control: "Retract",
  unpublish_confirm_hint: "Tap again to confirm",
  create_publish_hint: "You can add ratings, genre, and cover art when you publish.",
  generator_create_upload: "Create / Upload",
  generator_generate: "Generate",
  generator_vibes_prompt: "Vibes (choose as many as you\u2019d like)",
  generator_vibes_required: "Pick at least one vibe.",
  generator_audience_prompt: "Who\u2019s your audience?",
  generator_audience_placeholder: "Select reading level",
  generator_characters_prompt: "How many characters?",
  generator_details_prompt: "Any details to add?",
  generator_details_placeholder: "Add any details to help guide the story\u2026",
  generator_record_cta: "Speak your vision",
  chuzi_ai_monomyth_hero: "Hero\u2019s Journey: the protagonist",
  chuzi_ai_monomyth_world: "Monomyth: ordinary world",
  chuzi_ai_monomyth_you: "Story Circle: zone of comfort",
  chuzi_ai_monomyth_need: "Story Circle: something isn\u2019t right",
  chuzi_ai_monomyth_go: "Monomyth: crossing the first threshold",
  chuzi_ai_monomyth_search: "Monomyth: road of trials",
  chuzi_ai_monomyth_find: "Monomyth: the ultimate boon",
  chuzi_ai_monomyth_take: "Monomyth: atonement with the father",
  chuzi_ai_monomyth_return: "Monomyth: crossing the return threshold",
  chuzi_ai_monomyth_change: "Monomyth: freedom to live",
  editor_ai_generate: "Generate with AI",
  editor_ai_generating: "Generating\u2026",
  editor_ai_mood_question: "What mood should this scene convey?",
  editor_ai_style_question: "What visual style do you want?",
  editor_ai_prompt_question: "Describe this scene",
  editor_ai_accept: "Accept",
  editor_ai_reject: "Reject",
  editor_ai_retry: "Try Again",
  editor_ai_feedback_prompt: "What should we change?",
  editor_ai_credit_cost: "1 credit per generation",
  spending_modal_title: "Purchase Credits",
  spending_modal_body: "You need more credits to continue. Choose how many to add.",
  spending_modal_no_payment: "Add a payment method to purchase credits.",
  spending_modal_credits_label: "Credits to add",
  spending_modal_price_label: "Total",
  spending_modal_admin_note: "Admin \u2014 credits are granted free of charge.",
  spending_modal_purchase: "Purchase Credits",
  spending_modal_grant: "Grant Credits",
  spending_modal_add_card: "Add Payment Method",
  spending_modal_card_last_four: "Card last four digits",
  spending_modal_card_label: "Card label (optional)",
  spending_modal_processing: "Processing\u2026",
  spending_modal_success: "Credits added.",
  spending_modal_error: "Could not complete purchase. Try again.",
  spending_modal_cancel: "Not now",
  spending_insufficient_credits: "Not enough credits. Purchase more to continue.",
  spending_add_credits_continue: "Add credits to continue",
  editor_ai_generating_scene: "Scene generating\u2026",
  editor_ai_style_badge: "Style",
  editor_ai_failed: "Generation failed. Please try again.",
  editor_media_attached: "This scene already has media attached.",
  editor_remove_media: "Remove Media",
  editor_media_question: "What's this scene's media?",
  editor_media_type_text: "Text",
  editor_media_type_imagery: "Imagery",
  editor_media_type_film: "Film",
  editor_media_preview_cta: "Preview",
  editor_media_preview_disabled: "Add text to enable preview.",
  editor_text_toolbar_label: "Text / Video",
  editor_text_font_label: "Font",
  editor_text_color_label: "Text Color",
  editor_text_background_label: "Background",
  editor_text_font_size_label: "Font Size",
  editor_text_placeholder: "Start writing scene media...",
  editor_line_add: "Add Text Block",
  editor_add_text: "Add Text",
  editor_add_video: "Add Video",
  editor_text_lines_section: "Text Lines",
  editor_line_editor_label: "Editor",
  editor_line_number: "Line",
  editor_select_line_hint: "Select a line to edit",
  editor_select_effect_hint: "Select an effect to edit",
  editor_select_choice_hint: "Select a choice to edit",
  editor_line_timestamp: "Appears at",
  editor_line_fade_in: "Fade In",
  editor_line_fade_out: "Fade Out",
  editor_line_duration: "Duration",
  editor_line_persist: "Stay on Screen",
  editor_effects_section: "Effects",
  editor_effects_add: "Add sounds, effects, etc",
  editor_add_sound_music: "Add Sound / Music",
  editor_add_fx: "Add FX",
  editor_node_list_section: "Layers",
  editor_exit_choice_label: "Go To The End",
  editor_bg_layer_label: "Background",
  editor_remove_layer: "Remove",
  editor_new_node: "New\u2026",
  editor_new_text: "Lines of Text",
  editor_new_choice: "Choice",
  editor_new_image: "Image",
  editor_new_video: "Video",
  editor_new_music: "Music",
  editor_new_sound: "Sound Effect",
  editor_new_logic: "Logic",
  editor_new_credits: "Chosen by\u2026",
  editor_credits_layer: "Credits",
  editor_logic_mode_set: "Set Variable",
  editor_logic_mode_evaluate: "Evaluate",
  editor_logic_variable_label: "Variable",
  editor_logic_value_label: "Value",
  editor_logic_operator_label: "Condition",
  editor_logic_then_layers: "Then activate layers",
  editor_logic_new_variable: "New variable\u2026",
  editor_insert_star_menu: "Insert New Scene\u2026",
  editor_select_node_hint: "Select a layer to edit",
  editor_effect_describe_prompt: "Describe what you want in detail",
  editor_effect_share_toggle: "Allow others to use this?",
  editor_effect_share_yes: "Yes, share with others",
  editor_effect_share_no: "No, keep it private",
  editor_effect_generating: "Generating\u2026",
  editor_effect_fade_in_sound: "Fade In Sound",
  editor_effect_fade_out_sound: "Fade Out Sound",
  editor_effect_fade_in_visual: "Fade In",
  editor_effect_fade_out_visual: "Fade Out",
  editor_timeline_label: "Timeline",
  editor_preview_label: "Preview",
  editor_preview_empty_hint: "Preview will appear here",
  editor_preview_interact_hint: "Preview \u2014 drag to position, resize from corner",
  editor_preview_play: "Play",
  editor_preview_pause: "Pause",
  editor_media_placeholder_imagery: "Imagery authoring is coming soon.",
  editor_media_placeholder_film: "Film authoring is coming soon.",
  editor_goto_scene: "Goto Scene",
  editor_scene_duration: "Scene Duration",
  editor_add_choice: "Add Choice",
  editor_arrow_tool: "Place Arrow",
  editor_goto_nullified: "Disabled \u2014 choices override goto",
  editor_remove_choice: "Remove Choice",
  editor_choice_target: "Destination Scene",
  editor_choices_empty_hint: "Set a goto scene or add a choice to create branching paths.",
  editor_goto_none: "None",
  editor_choice_label: "Choice",
  editor_choice_display_label: "Arrow Label",
  editor_choice_display_label_hint: "Leave blank to hide the label beneath the arrow. Lexicon keys like viewer_continue resolve to realm text.",
  editor_choice_display_label_empty: "No label",
  editor_choice_display_label_preview: "Preview",
  editor_choice_exit_target_hint: "Terminal exit \u2014 ends the story for viewers.",
  editor_flow_timeline: "Story Flow",
  editor_flow_goto_path: "Default Goto",
  editor_flow_add_choice_here: "Add Choice Here",
  editor_flow_choice_branch: "Branch",
  editor_flow_content_ref: "Content",
  editor_scene_duration_unit: "seconds",
  editor_scene_duration_override_hint: "Overrides preview playback length. Content: {duration}s",
  editor_arrow_scale: "Scale",
  editor_arrow_rotation: "Rotation",
  editor_arrow_rotate_hint: "Drag the handle above the arrow in preview to rotate",
  constellation_no_coverbox: "No cover",
  hud_edit_control: "Edit",
  hud_delete_control: "Delete",
  hud_publish_control: "Publish",
  hud_launch_control: "Launch",
  editor_publish_story: "Publish",
  viewer_loading: "Loading experience\u2026",
  viewer_preparing: "Cueing media\u2026",
  viewer_close: "Exit",
  viewer_complete: "End",
  viewer_stage_label: "Experience",
  viewer_choose_path: "Choose",
  viewer_scrub_label: "Playback position",
  create_button: "CREATE",
  publish_form_heading: "Publish checklist",
  tags_label: "Tags",
  tags_placeholder: "Search tags\u2026",
  tags_empty: "No tags yet",
  tags_required: "At least one tag is required.",
  tags_clear: "Clear tag filter",
  all_nav_search_placeholder: "Search tags\u2026",
  all_nav_sort_label: "Order by",
  all_nav_empty_nebula: "No stories",
  catalog_order_label: "Sort by",
  catalog_order_newest: "Newest",
  catalog_order_oldest: "Oldest",
  catalog_order_most_viewed: "Most viewed",
  catalog_order_least_viewed: "Least viewed",
  error_rate_limited: "Too many requests. Wait a moment and try again.",
  story_picker_label: "Stories",
  created_by: "Created by",
  chosen_by: "Chosen by",
  story_metadata_heading: "Story details",
  story_metadata_save: "Save",
  constellation_title_edit_hint: "Edit story title and details",
  director_profile_title: "Director profile",
  director_profile_name_label: "Name",
  director_profile_realm_label: "Experience realm",
  director_profile_image_label: "Image",
  director_profile_image_hint: "Realm-themed seal \u2014 switching the realm above swaps the seal. Custom uploads land with the V1 avatar endpoints.",
  director_profile_tab_profile: "Profile",
  director_profile_tab_experience_mapping: "Experience Mapping",
  director_profile_admin_only: "Admin only",
  director_profile_cancel: "Cancel",
  director_profile_close: "Close",
  director_profile_save: "Save",
  director_profile_saving: "Saving\u2026",
  director_profile_name_required: "Name is required.",
  director_profile_username_locked_hint: "Username is set at sign up and cannot be changed.",
  director_profile_save_failed: "Save failed",
  experience_mapping_loading: "Loading experience mapping\u2026",
  experience_mapping_empty: "No template hierarchy available yet.",
  experience_mapping_retry: "Retry",
  experience_mapping_story_label: "Story",
  experience_mapping_scene_label: "Scene",
  experience_mapping_action_label: "Action",
  experience_mapping_field_title: "Title",
  experience_mapping_field_description: "Description",
  experience_mapping_field_genre: "Genre",
  experience_mapping_field_content_rating: "Content rating",
  experience_mapping_field_color: "Color",
  experience_mapping_field_name: "Name",
  experience_mapping_field_type: "Type",
  experience_mapping_field_order: "Order",
  experience_mapping_field_duration: "Duration",
  experience_mapping_field_properties: "Properties",
  experience_mapping_field_subproperties: "Subproperties",
  experience_mapping_save_changes: "Save changes",
  experience_mapping_saved: "Saved",
  experience_mapping_save_error: "Could not save changes.",
  experience_mapping_delete_story: "Delete story",
  experience_mapping_delete_scene: "Delete scene",
  experience_mapping_delete_action: "Delete action",
  experience_mapping_delete_confirm: "Click again to confirm",
  experience_mapping_delete_error: "Delete failed.",
  experience_mapping_expand_all: "Expand all",
  experience_mapping_collapse_all: "Collapse all",
  experience_mapping_forbidden: "You do not have admin access for this section.",
  experience_mapping_bad_json: "JSON must be valid before saving.",
  experience_mapping_intro: "Edit realm vocabulary from largest to smallest. Generate JSON and paste it in chat for code application.",
  experience_mapping_dirty: "dirty changes",
  experience_mapping_export_ready: "No unsaved mapping edits yet.",
  experience_mapping_export_json: "Generate JSON export",
  experience_mapping_copy_json: "Copy JSON",
  experience_mapping_copied: "Copied",
  experience_mapping_paste_instruction: "Paste this JSON in chat and I will apply it to chuzi-shared.",
  experience_mapping_export_empty: "Export output appears here.",
  experience_mapping_select_realm: "Select realm",
  experience_mapping_group_major_idea: "Major Idea",
  experience_mapping_helper_realm_idea: "Highest-level concept for this realm.",
  experience_mapping_save_experience: "Save to experience",
  experience_mapping_saved_experience: "Saved to current experience. Some labels appear immediately.",
  auth_email_placeholder: "Email",
  auth_password_input_placeholder: "Password",
  auth_password_sign_in_button: "Sign In",
  auth_password_signing_in: "Signing in...",
  auth_signin_tab: "Sign in",
  auth_signup_tab: "Sign up",
  auth_signup_subtitle: "Create your account with secure sign-in.",
  auth_signin_subtitle: "Sign in with your username or email.",
  auth_sign_up_button: "Create account",
  auth_username_placeholder: "Username",
  auth_identifier_placeholder: "Username or email",
  auth_sign_in_button: "Log in",
  auth_continue_with_google: "Continue with Google",
  auth_magic_link_code_placeholder: "Sign-in code",
  auth_magic_link_enter_code: "Enter the code from your email to sign in.",
  auth_magic_link_sent_code: "Check your email for your sign-in code.",
  auth_code_required: "Sign-in code is required.",
  auth_identifier_required: "Username or email is required.",
  auth_identifier_not_found: "No account found with that username.",
  auth_signing_in: "Signing in...",
  auth_oidc_redirecting: "Redirecting to secure sign-in...",
  auth_oidc_failed: "Could not start sign-in.",
  auth_oidc_callback_processing: "Completing sign-in...",
  auth_oidc_verified: "Signed in. Redirecting...",
  auth_oidc_callback_failed: "Could not complete sign-in.",
  auth_oidc_token_missing: "Sign-in token was missing.",
  auth_magic_link_sent: "If that email is registered, a magic link has been sent.",
  auth_magic_link_sent_signup: "Check your email for your sign-up link.",
  auth_magic_link_verifying: "Verifying magic link...",
  auth_magic_link_verified: "Signed in. Redirecting...",
  auth_magic_link_failed: "This magic link is invalid or expired.",
  auth_magic_link_cta: "Use another email",
  auth_login_failed: "Sign-in failed.",
  auth_username_checking: "Checking username availability...",
  auth_username_available: "Username is available.",
  auth_username_unavailable: "Username is taken; updated to an available suggestion.",
  auth_username_required: "Username is required.",
  auth_username_update_failed: "Could not reserve a unique username.",
  experience_mapping_group_experience_root: "Experience Root",
  experience_mapping_group_node_types: "Node Types",
  experience_mapping_group_scene_structure: "Scene Structure",
  experience_mapping_group_media: "Media Terms",
  experience_mapping_group_counts: "Counts and Adjacent Labels",
  experience_mapping_helper_story: "Largest narrative unit.",
  experience_mapping_helper_scene: "Contained unit under story.",
  experience_mapping_helper_scene_choice: "Branching choice in a scene.",
  experience_mapping_helper_node: "Smallest flow node.",
  experience_mapping_helper_alt_media: "Smallest related media label."
};
var FALLBACK_LOCALES = {
  es: {
    genre: "G\xE9nero",
    story: "Historia",
    scene: "Escena",
    scene_choice: "Elecci\xF3n",
    player: "Reproductor",
    library: "Biblioteca",
    editor: "Editor",
    publish: "Publicar",
    the_end: "Fin",
    untitled_story: "Historia sin t\xEDtulo",
    menu_create_story: "Crear historia",
    menu_create_film: "Crear pel\xEDcula",
    film_title_placeholder: "T\xEDtulo de la pel\xEDcula",
    select_genre: "Seleccionar g\xE9nero",
    delete_story_verb: "Eliminar pel\xEDcula",
    created_by: "Creado por"
  },
  fr: {
    genre: "Genre",
    story: "Histoire",
    scene: "Sc\xE8ne",
    scene_choice: "Choix",
    player: "Lecteur",
    library: "Biblioth\xE8que",
    editor: "\xC9diteur",
    publish: "Publier",
    the_end: "Fin",
    untitled_story: "Histoire sans titre",
    menu_create_story: "Cr\xE9er une histoire",
    menu_create_film: "Cr\xE9er un film",
    film_title_placeholder: "Titre du film",
    select_genre: "S\xE9lectionner un genre",
    delete_story_verb: "Supprimer le film",
    created_by: "Cr\xE9\xE9 par"
  },
  de: {
    genre: "Genre",
    story: "Geschichte",
    scene: "Szene",
    publish: "Ver\xF6ffentlichen",
    the_end: "Ende",
    untitled_story: "Unbenannte Geschichte",
    menu_create_story: "Geschichte erstellen",
    film_title_placeholder: "Filmtitel",
    select_genre: "Genre ausw\xE4hlen",
    created_by: "Erstellt von"
  },
  pt: {
    genre: "G\xEAnero",
    story: "Hist\xF3ria",
    scene: "Cena",
    publish: "Publicar",
    the_end: "Fim",
    untitled_story: "Hist\xF3ria sem t\xEDtulo",
    menu_create_story: "Criar hist\xF3ria",
    film_title_placeholder: "T\xEDtulo do filme",
    select_genre: "Selecionar g\xEAnero",
    created_by: "Criado por"
  }
};
function resolveFallback(locale) {
  const overrides = locale && FALLBACK_LOCALES[locale];
  return overrides ? { ...FALLBACK_LEXICON, ...overrides } : { ...FALLBACK_LEXICON };
}
function resolveRealm(realmId, locale) {
  const realm = REALMS[realmId];
  const overrides = locale && realm.locales ? realm.locales[locale] : void 0;
  const runtimeOverrides = runtimeRealmLexiconOverrides[realmId];
  return {
    ...realm.lexicon,
    ...overrides ?? {},
    ...runtimeOverrides ?? {}
  };
}
function t(realmId, key, fallback = "", locale = null) {
  if (realmId && REALMS[realmId]) {
    const realmLex = resolveRealm(realmId, locale);
    if (realmLex[key] !== void 0) return realmLex[key];
  }
  const fb = resolveFallback(locale);
  return fb[key] ?? fallback;
}
function lexiconForRealm(realmId, locale = null) {
  const fb = resolveFallback(locale);
  if (!realmId || !REALMS[realmId]) {
    return fb;
  }
  return { ...fb, ...resolveRealm(realmId, locale) };
}

// src/themes/index.ts
var THEME_TOKENS = {
  cosmos: {
    bgDeep: "#04070d",
    bgMid: "#0a1020",
    accent: "#7eb8ff",
    accentSoft: "rgba(126, 184, 255, 0.35)",
    text: "#e8f0ff",
    muted: "rgba(232, 240, 255, 0.65)",
    effectLine: "#ffb347",
    textLine: "#7eb8ff",
    videoLine: "#ff7eb8",
    soundLine: "#ffb347",
    musicLine: "#ffd747",
    imageLine: "#47ffc4",
    choiceLine: "#f5c455",
    creditsLine: "#c8a0e8"
  },
  wilds: {
    bgDeep: "#0d120c",
    bgMid: "#152018",
    accent: "#7bc96f",
    accentSoft: "rgba(123, 201, 111, 0.35)",
    text: "#eef6ea",
    muted: "rgba(238, 246, 234, 0.7)",
    effectLine: "#b78aff",
    textLine: "#7bc96f",
    videoLine: "#e87bc9",
    soundLine: "#b78aff",
    musicLine: "#d4a0ff",
    imageLine: "#7affb3",
    choiceLine: "#b8e86f",
    creditsLine: "#d4a0ff"
  }
};
function getThemeTokens(realmId) {
  return THEME_TOKENS[realmId ?? "wilds"] ?? THEME_TOKENS.wilds;
}
var RealmThemeContext = createContext(null);
function RealmThemeProvider({
  realmId,
  locale = null,
  lexiconRevision = 0,
  children
}) {
  const value = useMemo(() => {
    return {
      realmId,
      locale,
      tokens: getThemeTokens(realmId),
      lexicon: lexiconForRealm(realmId, locale),
      t: (key, fallback = "") => t(realmId, key, fallback, locale)
    };
  }, [realmId, locale, lexiconRevision]);
  return /* @__PURE__ */ jsx(RealmThemeContext.Provider, { value, children });
}
function useRealmTheme() {
  const ctx = useContext(RealmThemeContext);
  if (!ctx) {
    throw new Error(
      "useRealmTheme: no RealmThemeProvider in tree. Wrap your app root with <RealmThemeProvider realmId={...} />."
    );
  }
  return ctx;
}
function Button({
  label,
  variant = "primary",
  style,
  ...rest
}) {
  const { tokens } = useRealmTheme();
  return /* @__PURE__ */ jsx(
    Pressable,
    {
      accessibilityRole: "button",
      style: ({ pressed }) => [
        styles.base,
        variant === "primary" ? { backgroundColor: tokens.accent } : {
          backgroundColor: "transparent",
          borderColor: tokens.accent,
          borderWidth: 1
        },
        pressed && { opacity: 0.85 },
        style
      ],
      ...rest,
      children: /* @__PURE__ */ jsx(
        Text,
        {
          style: [
            styles.label,
            {
              color: variant === "primary" ? tokens.bgDeep : tokens.accent
            }
          ],
          children: label
        }
      )
    }
  );
}
var styles = StyleSheet.create({
  base: {
    paddingHorizontal: 18,
    paddingVertical: 10,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center"
  },
  label: {
    fontSize: 14,
    fontWeight: "600",
    letterSpacing: 0.5
  }
});
function FilmCard({ film, onPress, style }) {
  const { tokens, t: t2 } = useRealmTheme();
  const title = film.title?.trim() || t2("untitled_story", "Untitled");
  const genre = film.genre?.trim() || t2("unknown_genre", "Unknown");
  const sceneLabel = t2("scenes_count", "scenes");
  const choiceLabel = t2("choices_count", "choices");
  const inner = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Text,
      {
        style: [styles2.title, { color: tokens.text }],
        numberOfLines: 2,
        children: title
      }
    ),
    /* @__PURE__ */ jsxs(Text, { style: [styles2.meta, { color: tokens.muted }], children: [
      genre,
      " \xB7 ",
      film.scenes_count,
      " ",
      sceneLabel,
      " \xB7 ",
      film.choices_count,
      " ",
      choiceLabel
    ] }),
    film.creator?.name ? /* @__PURE__ */ jsx(Text, { style: [styles2.creator, { color: tokens.accent }], children: film.creator.name }) : null
  ] });
  if (onPress) {
    return /* @__PURE__ */ jsx(
      Pressable,
      {
        accessibilityRole: "button",
        onPress,
        style: ({ pressed }) => [
          styles2.base,
          { backgroundColor: tokens.bgMid, borderColor: tokens.accentSoft },
          pressed && { opacity: 0.92 },
          style
        ],
        children: inner
      }
    );
  }
  return /* @__PURE__ */ jsx(
    View,
    {
      style: [
        styles2.base,
        { backgroundColor: tokens.bgMid, borderColor: tokens.accentSoft },
        style
      ],
      children: inner
    }
  );
}
var styles2 = StyleSheet.create({
  base: {
    padding: 16,
    borderRadius: 12,
    borderWidth: 1,
    gap: 6,
    minWidth: 240
  },
  title: {
    fontSize: 16,
    fontWeight: "700"
  },
  meta: {
    fontSize: 12
  },
  creator: {
    fontSize: 12,
    fontWeight: "600"
  }
});
function CreditBadge({ role, value, style }) {
  const { tokens } = useRealmTheme();
  const label = role === "viewer" ? "Viewer Credits" : "Creator Credits";
  return /* @__PURE__ */ jsxs(
    View,
    {
      style: [
        styles3.container,
        {
          borderColor: tokens.accent,
          backgroundColor: tokens.bgMid
        },
        style
      ],
      children: [
        /* @__PURE__ */ jsx(Text, { style: [styles3.label, { color: tokens.muted }], children: label }),
        /* @__PURE__ */ jsx(Text, { style: [styles3.value, { color: tokens.accent }], children: value.toLocaleString() })
      ]
    }
  );
}
var styles3 = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 8,
    borderWidth: 1
  },
  label: {
    fontSize: 12,
    fontWeight: "600",
    letterSpacing: 0.4,
    textTransform: "uppercase"
  },
  value: {
    fontSize: 16,
    fontWeight: "700"
  }
});

export { Button, CreditBadge, FilmCard, RealmThemeProvider, useRealmTheme };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map